import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Char19o2r8palgjof as Char } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  decodeSerializableElement$default1kkisaow5bg5n as decodeSerializableElement$default,
  decodeSerializableValue3h7ajfesxzjda as decodeSerializableValue,
  decodeSequentially27kmi8jnnsnbc as decodeSequentially,
  decodeCollectionSize3l4gjp9ef5h8u as decodeCollectionSize,
  Decoder23nde051s631g as Decoder,
  CompositeDecoder2tzm7wpwkr0og as CompositeDecoder,
} from './Decoding.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AbstractDecoderClass;
function AbstractDecoder() {
  if (AbstractDecoderClass === VOID) {
    class $ {
      i1q() {
        throw SerializationException().c1o(toString(getKClassFromExpression(this)) + " can't retrieve untyped values");
      }
      j1q() {
        return true;
      }
      k1q() {
        return null;
      }
      l1q() {
        var tmp = this.i1q();
        return typeof tmp === 'boolean' ? tmp : THROW_CCE();
      }
      m1q() {
        var tmp = this.i1q();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      n1q() {
        var tmp = this.i1q();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      o1q() {
        var tmp = this.i1q();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      p1q() {
        var tmp = this.i1q();
        return typeof tmp === 'bigint' ? tmp : THROW_CCE();
      }
      q1q() {
        var tmp = this.i1q();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      r1q() {
        var tmp = this.i1q();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      s1q() {
        var tmp = this.i1q();
        return tmp instanceof Char() ? tmp.e4_1 : THROW_CCE();
      }
      t1q() {
        var tmp = this.i1q();
        return typeof tmp === 'string' ? tmp : THROW_CCE();
      }
      u1q(enumDescriptor) {
        var tmp = this.i1q();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      v1q(descriptor) {
        return this;
      }
      w1q(deserializer, previousValue) {
        return this.x1q(deserializer);
      }
      y1q(descriptor) {
        return this;
      }
      z1q(descriptor) {
      }
      a1r(descriptor, index) {
        return this.l1q();
      }
      b1r(descriptor, index) {
        return this.m1q();
      }
      c1r(descriptor, index) {
        return this.n1q();
      }
      d1r(descriptor, index) {
        return this.o1q();
      }
      e1r(descriptor, index) {
        return this.p1q();
      }
      f1r(descriptor, index) {
        return this.q1q();
      }
      g1r(descriptor, index) {
        return this.r1q();
      }
      h1r(descriptor, index) {
        return this.s1q();
      }
      i1r(descriptor, index) {
        return this.t1q();
      }
      j1r(descriptor, index) {
        return this.v1q(descriptor.k1p(index));
      }
      k1r(descriptor, index, deserializer, previousValue) {
        return this.w1q(deserializer, previousValue);
      }
      m1r(descriptor, index, deserializer, previousValue) {
        // Inline function 'kotlinx.serialization.encoding.decodeIfNullable' call
        var isNullabilitySupported = deserializer.h1m().w1o();
        var tmp;
        if (isNullabilitySupported || this.j1q()) {
          tmp = this.w1q(deserializer, previousValue);
        } else {
          tmp = this.k1q();
        }
        return tmp;
      }
    }
    protoOf($).l1r = decodeSerializableElement$default;
    protoOf($).x1q = decodeSerializableValue;
    protoOf($).o1r = decodeSequentially;
    protoOf($).q1r = decodeCollectionSize;
    initMetadataForClass($, 'AbstractDecoder', VOID, VOID, [Decoder(), CompositeDecoder()]);
    AbstractDecoderClass = $;
  }
  return AbstractDecoderClass;
}
//region block: exports
export {
  AbstractDecoder as AbstractDecoder35guh02ubh2hm,
};
//endregion

//# sourceMappingURL=AbstractDecoder.mjs.map
